import { useTranslation } from "react-i18next";
const SelectAllCos = "Select All";
const TotalActi = "Total No. of Activities";
const styleBorR = "3px solid #d9d9d9";
export const AshaDetailscolumns = () => {
  const { t } = useTranslation("TopAsha");
  return [
    {
      field: "ashaName",
      header: t("ASHAName"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "ashaid",
      header: t("ASHAId"),
      headerStyle: { borderRight: styleBorR },
      bodyStyle: { borderRight: styleBorR },
      filter: true,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "mobileNo",
      header: t("ContactNo"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "stateName",
      header: t("State"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "district",
      header: t("District"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "talukas",
      header: t("Taluka"),
      filter: true,
      showFilterMenu: false,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "villagename",
      header: t("Village"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
      isCalendar: true,
    },
    {
      field: "totalActiveCases",
      header: t("TotalNofActCases"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "amount",
      header: t("PaidIncentive"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActivityCount",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "RemainderCount",
      header: t("ReminderStatus"),
      filter: false,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
      headerStyle: { borderLeft: styleBorR },
      bodyStyle: { borderLeft: styleBorR },
    },
  ];
};
export const AshaIncentiveColumns = () => {
  const { t } = useTranslation("TopAsha");
  return [
    {
      field: "select",
      header: t("Select All"),
      frozen: true,
    },
    {
      field: "ashaName",
      header: t("ASHAName"),
      showFilterMenu: false,
      filter: true,
      frozen: true,
    },
    {
      field: "ashaid",
      header: t("ASHAId"),
      showFilterMenu: false,
      filter: true,
      frozen: true,
    },
    {
      field: "mobileNo",
      header: t("ContactNo"),
      showFilterMenu: false,
      filter: true,
      alignFrozen: "left",
      headerStyle: { borderLeft: styleBorR, position: "sticky" },
      bodyStyle: { borderLeft: styleBorR },
    },
    {
      field: "stateName",
      header: t("State"),
      showFilterMenu: false,
      filter: false,
    },
    {
      field: "districtName",
      header: t("District"),
      showFilterMenu: false,
      filter: true,
    },
    {
      field: "talukaName",
      header: t("Taluka"),
      showFilterMenu: false,
      filter: true,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "villageName",
      header: t("Village"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActiveCases",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "paidIncentive",
      header: t("PaidIncentive"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActivityCount",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "remindersCount",
      header: t("ReminderStatus"),
      filter: false,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
      headerStyle: { borderLeft: styleBorR },
      bodyStyle: { borderLeft: styleBorR },
    },
  ];
};
export const AshaActiveInactiveColumns = (tabIndex) => {
  const { t } = useTranslation("TopAsha");
  const table = [
    { field: "select", header: t(SelectAllCos), frozen: true },
    {
      field: "role",
      header: t("Role"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
    },
    {
      field: "ashaName",
      header: t("ANM/ASHA Name"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
    },
    {
      field: "ashaId",
      header: t("ASHAId"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
    },

    {
      field: "contactNo",
      header: t("ContactNo"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
    },
    {
      headerStyle: { borderRight: styleBorR, position: "sticky" },
      bodyStyle: { borderRight: styleBorR },
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "stateName",
      header: t("State"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "districtName",
      header: t("District"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "talukaName",
      header: t("Taluka"),
      filter: true,
      showFilterMenu: false,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "villageName",
      header: t("Village"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
    },
    {
      headerStyle: { borderLeft: styleBorR, position: "sticky" },
      bodyStyle: { borderLeft: styleBorR },
      frozen: true,
      alignFrozen: "right",
    },
    {
      field: "reminderCount",
      header: t("ReminderStatus"),
      filter: false,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
    },
  ];
  if (tabIndex === 1) {
    table.push({
      field: "inactiveSince",
      header: t("lastActive"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
    });
  }
  return table;
};
export const ListOfAshasColumns = () => {
  const { t } = useTranslation("TopAsha");
  return [
    { field: "id", header: t("SrNo"), frozen: true },
    {
      field: "ashaName",
      header: t("ASHAName"),
      showFilterMenu: false,
      filter: true,
      frozen: true,
    },
    {
      field: "ashaid",
      header: t("ASHAId"),
      showFilterMenu: false,
      filter: true,
      frozen: true,
    },

    {
      field: "mobileNo",
      header: t("ContactNo"),
      showFilterMenu: false,
      filter: true,
      alignFrozen: "left",
      headerStyle: { borderLeft: styleBorR, position: "sticky" },
      bodyStyle: { borderLeft: styleBorR },
    },
    {
      field: "stateName",
      header: t("State"),
      showFilterMenu: false,
      filter: false,
    },
    {
      field: "districtName",
      header: t("District"),
      showFilterMenu: false,
      filter: true,
    },
    {
      field: "talukaName",
      header: t("Taluka"),
      showFilterMenu: false,
      filter: true,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "villageName",
      header: t("Village"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActiveCases",
      header: t("TotalNofActCases"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "paidIncentive",
      header: t("PaidIncentive"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActivityCount",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },

    {
      field: "remindersCount",
      header: t("ReminderStatus"),
      filter: false,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
      headerStyle: { borderLeft: styleBorR },
      bodyStyle: { borderLeft: styleBorR },
    },
  ];
};

export const ActivityandIncentives = [
  {
    field: "activityname",
    header: "Activity Name",
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "activitycount",
    header: "Activity Count",
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "ashaCount",
    header: "No. of Asha",
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "amountpercase",
    header: "Amount per case",
    filter: false,
    showFilterMenu: false,
  },
];

export const ApprovedRequestsColumns = [
  {
    field: "name",
    header: "Asha Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "ashaid",
    header: "Asha Id",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "claimDate",
    header: "Date of Claim",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "approveddate",
    header: "Approval Date",
    filter: true,
    showFilterMenu: false,
  },
  {
    field: "amount",
    header: "Total Claim requested",
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "totalCount",
    header: TotalActi,
    filter: false,
    showFilterMenu: false,
  },
];

export const PendingRequestsColumns = [
  {
    field: "name",
    header: "Asha Name",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "ashaid",
    header: "Asha Id",
    filter: true,
    showFilterMenu: false,
    frozen: true,
  },
  {
    field: "totalCount",
    header: TotalActi,
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "amount",
    header: "Total Claim requested",
    filter: false,
    showFilterMenu: false,
  },
  {
    field: "pendingSince",
    header: "Pending Since",
    filter: false,
    showFilterMenu: false,
  },
];

export const TotalAshaTable = () => {
  const { t } = useTranslation("TopAsha");
  return [
    {
      field: "ashaName",
      header: t("ASHAName"),
      filter: true,
      frozen: true,
      alignFrozen: "left",
      showFilterMenu: false,
    },
    {
      field: "ashaid",
      header: t("ASHAId"),
      filter: false,
      frozen: true,
      alignFrozen: "left",
      showFilterMenu: false,
    },
    {
      frozen: true,
      headerStyle: { borderRight: styleBorR },
      bodyStyle: { borderRight: styleBorR },
      alignFrozen: "left",
    },
    {
      field: "mobileNo",
      header: t("ContactNo"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "stateName",
      header: t("State"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "districtName",
      header: t("District"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "talukaName",
      header: t("Taluka"),
      filter: true,
      showFilterMenu: false,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
      // isCalendar: true,
    },
    {
      field: "totalActiveCases",
      header: t("TotalNofActCases"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActivityCount",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },
    {
      headerStyle: { borderLeft: styleBorR },
      bodyStyle: { borderLeft: styleBorR },
      frozen: true,
      alignFrozen: "right",
      filter: false,
    },
    {
      field: "reminderCount",
      header: t("ReminderStatus"),
      filter: false,
      frozen: true,
      alignFrozen: "right",
      showFilterMenu: false,
    },
  ];
};
export const SELECT_ALL_COLUMN = {
  field: "select",
  header: SelectAllCos,
  frozen: true,
  filter: false,
};
export const AshaDeployedByRegionTable = (t, inactiveAshaList) => {
  const columns = [
    {
      field: "select",
      header: t("Select"),
      frozen: true,
      alignFrozen: "left",
      showFilterMenu: false,
      filter: false,
    },
    {
      field: "ashaName",
      header: t("ASHAName"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "left",
    },
    {
      field: "ashaid",
      header: t("ASHAId"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
      headerStyle: { borderRight: styleBorR },
      bodyStyle: { borderRight: styleBorR },
    },
    {
      field: "mobileNo",
      header: t("ContactNo"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "stateName",
      header: t("State"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "district",
      header: t("District"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "talukas",
      header: t("Taluka"),
      filter: true,
      showFilterMenu: false,
    },
    { field: "phcName", header: t("PHC"), filter: true, showFilterMenu: false },
    {
      field: "subcenterName",
      header: t("Subcenter"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "villageName",
      header: t("Village"),
      filter: true,
      showFilterMenu: false,
    },
    {
      field: "joiningDate",
      header: t("JoiningDate"),
      filter: false,
      showFilterMenu: false,
      // isCalendar: true,
    },
    {
      field: "totalActiveCases",
      header: t("TotalNofActCases"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "totalActivityCount",
      header: t("TotalNoofActivities"),
      filter: false,
      showFilterMenu: false,
    },
    {
      field: "RemainderCount",
      header: t("ReminderStatus"),
      filter: false,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
      headerStyle: { borderLeft: styleBorR },
      bodyStyle: { borderLeft: styleBorR },
    },
  ];
  if (inactiveAshaList > 0) {
    columns.push({
      field: "inactiveSince",
      header: t("lastActive"),
      filter: true,
      showFilterMenu: false,
      frozen: true,
      alignFrozen: "right",
    });
  }

  return columns;
};

export const typeOptions = [
  { label: "Child Care", value: "childCare", key: "childCare" },
  { label: "App Help", value: "appHelp", key: "appHelp" },
  { label: "Functional", value: "Functional Videos", key: "func" },
  { label: "PNC", value: "pnc", key: "pnc" },
  { label: "ANC", value: "anc", key: "anc" },
  { label: "Educational", value: "Educational Videos", key: "educ" },
];

export const audienceOptions = [
  { key: "asha", label: "ASHA", value: "ASHA" },
  { key: "ANM", label: "ANM", value: "ANM" },
  { key: "mother", label: "Mother", value: "mother" },
  { key: "block", label: "Block Faciliator", value: "block" },
];
